import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

export default function ModalComponent() {
  const [show, setShow] = useState(true)

  // Handlers to open/close
  const handleClose = () => setShow(false)

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div style={{ margin: "0 auto", maxWidth: 400 }}>
            <StaticImage
              src="../images/jvm-comunicado.jpg"
              quality={100}
              formats={["AUTO", "WEBP", "AVIF"]}
              alt="Comunicado JVM Aço"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
